export const AuditTierHeader = [
    {
      label: "date",
      key: "date"
    },
    {
      label: "loyalty_id",
      key: "loyalty_id"
    },
    {
      label: "current_tier",
      key: "current_tier"
    },
    {
      label: "current_program",
      key: "current_program"
    },
    {
      label: "desired_tier",
      key: "desired_tier"
    },
    {
      label: "desired_program",
      key: "desired_program"
    },
    {
      label: "desired_system_managed_flag",
      key: "desired_system_managed_flag"
    },
    {
      label: "reason_code",
      key: "reason_code"
    },
    {
      label: "ship_to_number",
      key: "ship_to_number"
    },
    {
      label: "billing_account",
      key: "billing_account"
    },
    {
      label: "altered_user_id",
      key: "altered_user_id"
    }
];

export const dormanteader = [
  
  {
    label: "Loyalty ID",
    key: "loyalty_id"
  }
  
];